import { createClient } from '@supabase/supabase-js';

import { Database } from '@/types/Supabase';

export const supabase = createClient<Database>(
  import.meta.env.VITE_SUPABASE_URL || `${import.meta.env.VITE_API_ORIGIN}/supabase`,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
);
